export default __webpack_public_path__ + "static/media/settingsicon.1dd6fa03.svg";